import {
  CHECK_CALENDAR_CAN_BE_DELETED,
  CHECK_CALENDAR_CAN_BE_DELETED_FAILED,
  CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS,
  CLONE_CALENDAR,
  CLONE_CALENDAR_FAILED,
  CLONE_CALENDAR_SUCCESS,
  CREATE_BOOKING,
  CREATE_BOOKING_FAILED,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_CALENDAR,
  CREATE_BOOKING_CALENDAR_FAILED,
  CREATE_BOOKING_CALENDAR_SUCCESS,
  CREATE_SUB_CALENDAR,
  CREATE_SUB_CALENDAR_FAILED,
  CREATE_SUB_CALENDAR_SUCCESS,
  DELETE_CALENDAR,
  DELETE_CALENDAR_FAILED,
  DELETE_CALENDAR_SUCCESS,
  DELETE_SUB_CALENDAR,
  DELETE_SUB_CALENDAR_FAILED,
  DELETE_SUB_CALENDAR_SUCCESS,
  GET_ALL_CALENDARS,
  GET_ALL_CALENDARS_FAILED,
  GET_ALL_CALENDARS_SUCCESS,
  GET_ALL_SUB_CALENDARS,
  GET_ALL_SUB_CALENDARS_FAILED,
  GET_ALL_SUB_CALENDARS_SUCCESS,
  GET_BOOKINGS,
  GET_BOOKINGS_FAILED,
  GET_BOOKINGS_SUCCESS,
  GET_CALENDAR,
  GET_BOOKING_CALENDARS,
  GET_BOOKING_CALENDARS_FAILED,
  GET_BOOKING_CALENDARS_SUCCESS,
  GET_CALENDAR_FAILED,
  GET_CALENDAR_SUCCESS,
  GET_SUB_CALENDAR,
  GET_SUB_CALENDARS,
  GET_SUB_CALENDARS_FAILED,
  GET_SUB_CALENDARS_SUCCESS,
  GET_SUB_CALENDAR_FAILED,
  GET_SUB_CALENDAR_SUCCESS,
  HIDE_CLONE_CALENDAR_MODAL,
  HIDE_CREATE_BOOKING_MODAL,
  HIDE_CREATE_BOOKING_WARNING_MODAL,
  HIDE_DELETE_CALENDAR_MODAL,
  HIDE_DELETE_SUB_CALENDAR_MODAL,
  OPEN_CLONE_CALENDAR_MODAL,
  OPEN_CREATE_BOOKING_MODAL,
  OPEN_CREATE_BOOKING_WARNING_MODAL,
  OPEN_DELETE_CALENDAR_MODAL,
  OPEN_DELETE_SUB_CALENDAR_MODAL,
  RESET_SELECTED_CALENDAR,
  RESET_SUB_CALENDAR,
  UPDATE_BOOKING_CALENDAR,
  UPDATE_BOOKING_CALENDAR_FAILED,
  UPDATE_BOOKING_CALENDAR_SUCCESS,
  UPDATE_SUB_CALENDAR,
  UPDATE_SUB_CALENDAR_FAILED,
  UPDATE_SUB_CALENDAR_STATUS,
  UPDATE_SUB_CALENDAR_STATUS_FAILED,
  UPDATE_SUB_CALENDAR_STATUS_SUCCESS,
  UPDATE_SUB_CALENDAR_SUCCESS,
  SET_BOOKING_CHECKOUT_SESSION,
  GET_SELECTED_BOOKING,
  GET_SELECTED_BOOKING_SUCCESS,
  GET_SELECTED_BOOKING_FAILED,
  RESET_SELECTED_BOOKING,
  CLONE_SUB_CALENDAR,
  CLONE_SUB_CALENDAR_SUCCESS,
  CLONE_SUB_CALENDAR_FAILED,
  REORDER_CALENDARS,
  REORDER_SUB_CALENDARS,
  REORDER_CALENDARS_SUCCESS,
  REORDER_SUB_CALENDARS_SUCCESS,
  CONNECT_OUTLOOK,
  CONNECT_OUTLOOK_SUCCESS,
  CONNECT_OUTLOOK_FAILED,
  DISCONNECT_CALENDAR,
  DISCONNECT_CALENDAR_SUCCESS,
  DISCONNECT_CALENDAR_FAILED,
  GET_OUTLOOK_CALENDARS,
  GET_OUTLOOK_CALENDARS_SUCCESS,
  GET_OUTLOOK_CALENDARS_FAILED,
  SYNC_OUTLOOK_CALENDARS,
  SYNC_OUTLOOK_CALENDARS_SUCCESS,
  SYNC_OUTLOOK_CALENDARS_FAILED,
  GET_SUB_CALENDAR_REPORTS,
  GET_SUB_CALENDAR_REPORTS_SUCCESS,
  GET_SUB_CALENDAR_REPORTS_FAILED,
  GET_BOOKING_DATE_REPORTS,
  GET_BOOKING_DATE_REPORTS_SUCCESS,
  GET_BOOKING_DATE_REPORTS_FAILED,
  RESET_BOOKING_DATE_REPORTS,
  GET_CALENDAR_GROUP_REPORTS,
  GET_CALENDAR_GROUP_REPORTS_SUCCESS,
  GET_CALENDAR_GROUP_REPORTS_FAILED,
  GET_BOOKING_STATUS_REPORTS,
  GET_BOOKING_STATUS_REPORTS_SUCCESS,
  GET_BOOKING_STATUS_REPORTS_FAILED,
  GET_USER_BOOKING_REPORTS,
  GET_USER_BOOKING_REPORTS_SUCCESS,
  GET_USER_BOOKING_REPORTS_FAILED,
  GET_BOOKING_REPORTS,
  GET_BOOKING_REPORTS_SUCCESS,
  GET_BOOKING_REPORTS_FAILED,
  UPDATE_BOOKING,
  UPDATE_BOOKING_SUCCESS,
  UPDATE_BOOKING_FAILED,
  CANCEL_BOOKING,
  CANCEL_BOOKING_SUCCESS,
  CANCEL_BOOKING_FAILED,
  REFUND_BOOKING,
  REFUND_BOOKING_SUCCESS,
  REFUND_BOOKING_FAILED,
  RESET_BOOKING_FEATURE,
} from "./actionTypes"

export const getBookingCalendars = params => ({
  type: GET_BOOKING_CALENDARS,
  payload: params,
})

export const getBookingCalendarsSuccess = response => ({
  type: GET_BOOKING_CALENDARS_SUCCESS,
  payload: response,
})

export const getBookingCalendarsFailed = error => ({
  type: GET_BOOKING_CALENDARS_FAILED,
  payload: error,
})

export const getBookings = params => ({
  type: GET_BOOKINGS,
  payload: params,
})

export const getBookingsSuccess = response => ({
  type: GET_BOOKINGS_SUCCESS,
  payload: response,
})

export const getBookingsFailed = error => ({
  type: GET_BOOKINGS_FAILED,
  payload: error,
})

export const getSubCalendars = params => ({
  type: GET_SUB_CALENDARS,
  payload: params,
})

export const getSubCalendarsSuccess = response => ({
  type: GET_SUB_CALENDARS_SUCCESS,
  payload: response,
})

export const getSubCalendarsFailed = error => ({
  type: GET_SUB_CALENDARS_FAILED,
  payload: error,
})

export const updateSubCalendarStatus = params => ({
  type: UPDATE_SUB_CALENDAR_STATUS,
  payload: params,
})

export const updateSubCalendarStatusSuccess = response => ({
  type: UPDATE_SUB_CALENDAR_STATUS_SUCCESS,
  payload: response,
})

export const updateSubCalendarStatusFailed = error => ({
  type: UPDATE_SUB_CALENDAR_STATUS_FAILED,
  payload: error,
})

export const createBookingCalendar = params => ({
  type: CREATE_BOOKING_CALENDAR,
  payload: params,
})

export const createBookingCalendarSuccess = response => ({
  type: CREATE_BOOKING_CALENDAR_SUCCESS,
  payload: response,
})

export const createBookingCalendarFailed = error => ({
  type: CREATE_BOOKING_CALENDAR_FAILED,
  payload: error,
})

export const resetSelectedCalendar = () => ({
  type: RESET_SELECTED_CALENDAR,
  payload: {},
})

export const updateBookingCalendar = params => ({
  type: UPDATE_BOOKING_CALENDAR,
  payload: params,
})

export const updateBookingCalendarSuccess = response => ({
  type: UPDATE_BOOKING_CALENDAR_SUCCESS,
  payload: response,
})

export const updateBookingCalendarFailed = error => ({
  type: UPDATE_BOOKING_CALENDAR_FAILED,
  payload: error,
})

export const getSubCalendar = params => ({
  type: GET_SUB_CALENDAR,
  payload: params,
})

export const getSubCalendarSuccess = response => ({
  type: GET_SUB_CALENDAR_SUCCESS,
  payload: response,
})

export const getSubCalendarFailed = error => ({
  type: GET_SUB_CALENDAR_FAILED,
  payload: error,
})

export const resetSubCalendar = () => ({
  type: RESET_SUB_CALENDAR,
  payload: {},
})

export const getAllCalendars = params => ({
  type: GET_ALL_CALENDARS,
  payload: params,
})

export const getAllCalendarsSuccess = response => ({
  type: GET_ALL_CALENDARS_SUCCESS,
  payload: response,
})

export const getAllCalendarsFailed = error => ({
  type: GET_ALL_CALENDARS_FAILED,
  payload: error,
})

export const createBooking = params => ({
  type: CREATE_BOOKING,
  payload: params,
})

export const createBookingSuccess = response => ({
  type: CREATE_BOOKING_SUCCESS,
  payload: response,
})

export const createBookingFailed = error => ({
  type: CREATE_BOOKING_FAILED,
  payload: error,
})

export const openCreateBookingModal = () => ({
  type: OPEN_CREATE_BOOKING_MODAL,
  payload: {},
})

export const hideCreateBookingModal = () => ({
  type: HIDE_CREATE_BOOKING_MODAL,
  payload: {},
})

export const openCreateBookingWarningModal = () => ({
  type: OPEN_CREATE_BOOKING_WARNING_MODAL,
  payload: {},
})

export const hideCreateBookingWarningModal = () => ({
  type: HIDE_CREATE_BOOKING_WARNING_MODAL,
  payload: {},
})

export const getAllSubCalendars = params => ({
  type: GET_ALL_SUB_CALENDARS,
  payload: params,
})

export const getAllSubCalendarsSuccess = response => ({
  type: GET_ALL_SUB_CALENDARS_SUCCESS,
  payload: response,
})

export const getAllSubCalendarsFailed = error => ({
  type: GET_ALL_SUB_CALENDARS_FAILED,
  payload: error,
})

export const createSubCalendar = params => ({
  type: CREATE_SUB_CALENDAR,
  payload: params,
})

export const createSubCalendarSuccess = response => ({
  type: CREATE_SUB_CALENDAR_SUCCESS,
  payload: response,
})

export const createSubCalendarFailed = error => ({
  type: CREATE_SUB_CALENDAR_FAILED,
  payload: error,
})

export const cloneCalendar = params => ({
  type: CLONE_CALENDAR,
  payload: params,
})

export const cloneCalendarSuccess = response => ({
  type: CLONE_CALENDAR_SUCCESS,
  payload: response,
})

export const cloneCalendarFailed = error => ({
  type: CLONE_CALENDAR_FAILED,
  payload: error,
})

export const openCloneCalendarModal = () => ({
  type: OPEN_CLONE_CALENDAR_MODAL,
  payload: {},
})

export const hideCloneCalendarModal = () => ({
  type: HIDE_CLONE_CALENDAR_MODAL,
  payload: {},
})

export const deleteCalendar = params => ({
  type: DELETE_CALENDAR,
  payload: params,
})

export const deleteCalendarSuccess = response => ({
  type: DELETE_CALENDAR_SUCCESS,
  payload: response,
})

export const deleteCalendarFailed = error => ({
  type: DELETE_CALENDAR_FAILED,
  payload: error,
})

export const openDeleteCalendarModal = () => ({
  type: OPEN_DELETE_CALENDAR_MODAL,
  payload: {},
})

export const hideDeleteCalendarModal = () => ({
  type: HIDE_DELETE_CALENDAR_MODAL,
  payload: {},
})

export const checkCalendarCanBeDeleted = params => ({
  type: CHECK_CALENDAR_CAN_BE_DELETED,
  payload: params,
})

export const checkCalendarCanBeDeletedSuccess = response => ({
  type: CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS,
  payload: response,
})

export const checkCalendarCanBeDeletedFailed = error => ({
  type: CHECK_CALENDAR_CAN_BE_DELETED_FAILED,
  payload: error,
})

export const getCalendar = params => ({
  type: GET_CALENDAR,
  payload: params,
})

export const getCalendarSuccess = response => ({
  type: GET_CALENDAR_SUCCESS,
  payload: response,
})

export const getCalendarFailed = error => ({
  type: GET_CALENDAR_FAILED,
  payload: error,
})

export const deleteSubCalendar = params => ({
  type: DELETE_SUB_CALENDAR,
  payload: params,
})

export const deleteSubCalendarSuccess = response => ({
  type: DELETE_SUB_CALENDAR_SUCCESS,
  payload: response,
})

export const deleteSubCalendarFailed = error => ({
  type: DELETE_SUB_CALENDAR_FAILED,
  payload: error,
})

export const openDeleteSubCalendarModal = () => ({
  type: OPEN_DELETE_SUB_CALENDAR_MODAL,
  payload: {},
})

export const hideDeleteSubCalendarModal = () => ({
  type: HIDE_DELETE_SUB_CALENDAR_MODAL,
  payload: {},
})

export const updateSubCalendar = params => ({
  type: UPDATE_SUB_CALENDAR,
  payload: params,
})

export const updateSubCalendarSuccess = response => ({
  type: UPDATE_SUB_CALENDAR_SUCCESS,
  payload: response,
})

export const updateSubCalendarFailed = error => ({
  type: UPDATE_SUB_CALENDAR_FAILED,
  payload: error,
})

export const setBookingCheckoutSession = params => ({
  type: SET_BOOKING_CHECKOUT_SESSION,
  payload: params,
})

export const getSelectedBooking = params => ({
  type: GET_SELECTED_BOOKING,
  payload: params,
})

export const getSelectedBookingSuccess = response => ({
  type: GET_SELECTED_BOOKING_SUCCESS,
  payload: response,
})

export const getSelectedBookingFailed = error => ({
  type: GET_SELECTED_BOOKING_FAILED,
  payload: error,
})

export const resetSelectedBooking = () => ({
  type: RESET_SELECTED_BOOKING,
  payload: {},
})

export const cloneSubCalendar = params => ({
  type: CLONE_SUB_CALENDAR,
  payload: params,
})

export const cloneSubCalendarSuccess = response => ({
  type: CLONE_SUB_CALENDAR_SUCCESS,
  payload: response,
})

export const cloneSubCalendarFailed = error => ({
  type: CLONE_SUB_CALENDAR_FAILED,
  payload: error,
})

export const reorderCalendars = params => ({
  type: REORDER_CALENDARS,
  payload: params,
})

export const reorderSubCalendars = params => ({
  type: REORDER_SUB_CALENDARS,
  payload: params,
})

export const reorderCalendarSuccess = response => ({
  type: REORDER_CALENDARS_SUCCESS,
  payload: response,
})

export const reorderSubCalendarsSuccess = response => ({
  type: REORDER_SUB_CALENDARS_SUCCESS,
  payload: response,
})

export const connectOutlook = params => ({
  type: CONNECT_OUTLOOK,
  payload: params,
})

export const connectOutlookSuccess = response => ({
  type: CONNECT_OUTLOOK_SUCCESS,
  payload: response,
})

export const connectOutlookFailed = error => ({
  type: CONNECT_OUTLOOK_FAILED,
  payload: error,
})

export const disconnectCalendar = params => ({
  type: DISCONNECT_CALENDAR,
  payload: params,
})

export const disconnectCalendarSuccess = response => ({
  type: DISCONNECT_CALENDAR_SUCCESS,
  payload: response,
})

export const disconnectCalendarFailed = error => ({
  type: DISCONNECT_CALENDAR_FAILED,
  payload: error,
})

export const getOutlookCalendars = values => ({
  type: GET_OUTLOOK_CALENDARS,
  payload: values,
})

export const getOutlookCalendarsSuccess = response => ({
  type: GET_OUTLOOK_CALENDARS_SUCCESS,
  payload: response,
})

export const getOutlookCalendarsFailed = error => ({
  type: GET_OUTLOOK_CALENDARS_FAILED,
  payload: error,
})

export const syncOutlookCalendars = params => ({
  type: SYNC_OUTLOOK_CALENDARS,
  payload: params,
})

export const syncOutlookCalendarsSuccess = response => ({
  type: SYNC_OUTLOOK_CALENDARS_SUCCESS,
  payload: response,
})

export const syncOutlookCalendarsFailed = error => ({
  type: SYNC_OUTLOOK_CALENDARS_FAILED,
  payload: error,
})

export const getSubCalendarReports = params => ({
  type: GET_SUB_CALENDAR_REPORTS,
  payload: params,
})

export const getSubCalendarReportsSuccess = response => ({
  type: GET_SUB_CALENDAR_REPORTS_SUCCESS,
  payload: response,
})

export const getSubCalendarReportsFailed = error => ({
  type: GET_SUB_CALENDAR_REPORTS_FAILED,
  payload: error,
})

export const getBookingDateReports = params => ({
  type: GET_BOOKING_DATE_REPORTS,
  payload: params,
})

export const getBookingDateReportsSuccess = response => ({
  type: GET_BOOKING_DATE_REPORTS_SUCCESS,
  payload: response,
})

export const getBookingDateReportsFailed = error => ({
  type: GET_BOOKING_DATE_REPORTS_FAILED,
  payload: error,
})

export const resetBookingDateReports = () => ({
  type: RESET_BOOKING_DATE_REPORTS,
  payload: {},
})

export const getCalendarGroupReports = params => ({
  type: GET_CALENDAR_GROUP_REPORTS,
  payload: params,
})

export const getCalendarGroupReportsSuccess = response => ({
  type: GET_CALENDAR_GROUP_REPORTS_SUCCESS,
  payload: response,
})

export const getCalendarGroupReportsFailed = error => ({
  type: GET_CALENDAR_GROUP_REPORTS_FAILED,
  payload: error,
})

export const getBookingStatusReports = params => ({
  type: GET_BOOKING_STATUS_REPORTS,
  payload: params,
})

export const getBookingStatusReportsSuccess = response => ({
  type: GET_BOOKING_STATUS_REPORTS_SUCCESS,
  payload: response,
})

export const getBookingStatusReportsFailed = error => ({
  type: GET_BOOKING_STATUS_REPORTS_FAILED,
  payload: error,
})

export const getUserBookingReports = params => ({
  type: GET_USER_BOOKING_REPORTS,
  payload: params,
})

export const getUserBookingReportsSuccess = response => ({
  type: GET_USER_BOOKING_REPORTS_SUCCESS,
  payload: response,
})

export const getUserBookingReportsFailed = error => ({
  type: GET_USER_BOOKING_REPORTS_FAILED,
  payload: error,
})

export const getBookingReports = params => ({
  type: GET_BOOKING_REPORTS,
  payload: params,
})

export const getBookingReportsSuccess = response => ({
  type: GET_BOOKING_REPORTS_SUCCESS,
  payload: response,
})

export const getBookingReportsFailed = error => ({
  type: GET_BOOKING_REPORTS_FAILED,
  payload: error,
})

export const updateBooking = params => ({
  type: UPDATE_BOOKING,
  payload: params,
})

export const updateBookingSuccess = response => ({
  type: UPDATE_BOOKING_SUCCESS,
  payload: response,
})

export const updateBookingFailed = error => ({
  type: UPDATE_BOOKING_FAILED,
  payload: error,
})

export const cancelBooking = params => ({
  type: CANCEL_BOOKING,
  payload: params,
})

export const cancelBookingSuccess = response => ({
  type: CANCEL_BOOKING_SUCCESS,
  payload: response,
})

export const cancelBookingFailed = error => ({
  type: CANCEL_BOOKING_FAILED,
  payload: error,
})

export const refundBooking = params => ({
  type: REFUND_BOOKING,
  payload: params,
})

export const refundBookingSuccess = response => ({
  type: REFUND_BOOKING_SUCCESS,
  payload: response,
})

export const refundBookingFailed = error => ({
  type: REFUND_BOOKING_FAILED,
  payload: error,
})

export const resetBookingFeature = () => ({
  type: RESET_BOOKING_FEATURE,
  payload: {},
})
